import { UserContext } from "../providers/UserProvider";
import { useContext } from "react";

export default function useUserContext() {
  return useContext(UserContext);
}
